import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // List of paths that don't require authentication
        const publicPaths = ['/signin', '/signup', '/forgot-password', '/reset-password'];

        // Check if the current path is in the public paths list
        const currentPath = location.pathname;
        const isPublicPath = publicPaths.some(path => currentPath.startsWith(path));

        // Only redirect to signin if not on a public path
        if (!loading && user === null && !isPublicPath) {
            navigate("/signin", { replace: true });
        }
    }, [navigate, user, loading, location.pathname]);

    if (loading) {
        return <div className="flex justify-center items-center h-screen"><div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500 dark:border-blue-300"></div></div>
    }

    // If we're on a non-protected route or the user is authenticated, render the children
    return (user || location.pathname.startsWith('/forgot-password') || location.pathname.startsWith('/reset-password')) ? children : null;
}